import { ZodError, ZodObject, ZodRawShape } from 'zod'

import { ApplicationError, ErrorType } from '../types'

export class GuardInput {
	static check<T extends ZodRawShape>(schema: ZodObject<T>, input: unknown) {
		try {
			schema.parse(input)
			return
		} catch (error) {
			const errors = (error as ZodError).errors.reduce(
				(acc, err) => {
					if (err.message === 'Required') {
						acc[err.path[0] as string] = `The ${err.path[0]} is required`
					} else if (
						err.code === 'invalid_type' &&
						err.message !== 'Required'
					) {
						acc[err.path[0] as string] = 'The field format is invalid'
					} else {
						acc[err.path[0] as string] = err.message
					}
					return acc
				},
				{} as Record<string, string>
			)

			return new ApplicationError({
				type: ErrorType.InvalidInput,
				message: 'Invalid input',
				inputErrors: errors,
				code: 'invalid_input'
			})
		}
	}
}
